import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import moment from "moment";
import { jsPDF } from "jspdf";
import autotable from "jspdf-autotable";
import * as XLSX from "xlsx";
import ReactPaginate from "react-paginate";
import { EXLDownloadIcon, PDFDownloadIcon } from "../../../SvgIconsData";
import Skeleton from "react-loading-skeleton";
import { BackIcon } from "../../../assets/icons/iconshere";

const itemsPerPage = 250; 

const TotalTrainings = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const [list, setList] = useState([]);
  const [startEndDate, setStartEndDate] = useState({
    start: null,
    end: null,
  });
  const configData = useSelector((state) => state.configSlice);
  const userData = useSelector((state) => state.userSlice);
  const { filter, group } = location.state || null;
  const groupId = params?.groupId;
  const [loading, setLoading] = useState(true);

  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0); 

  const getTotalTrainingUserList = async (selectedPage = 0) => {
    try {
      setLoading(true);

      const page = selectedPage + 1; 
      const count = itemsPerPage;

      let { data } = await axios.get(
        `${configData.config.API_URL}/api/dashboard/group/trainingList/${configData.config.MODE}/${groupId}?filter=${filter}&page=${page}&limit=${count}`,
        {
          headers: {
            Authorization: `Bearer ${userData.token}`,
            "Content-Type": "application/json",
          },
        },
      );

      setList(data?.data || []);

      setStartEndDate({
        start: data?.start,
        end: data?.end,
      });

      setPageCount(Math.ceil((data?.total || 0) / itemsPerPage));

      setCurrentPage(selectedPage);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getTotalTrainingUserList();
  }, []);

  const handlePageClick = (event) => {
    getTotalTrainingUserList(event.selected);
  };

  const generatePDF = () => {
    const doc = new jsPDF("l", "mm", "a4");
    var headerSummary = [
      ["Trainings Report", ""],
      ["Generated by", `${userData?.user?.name}`],
      ["Generated at", moment().format("DD/MM/YYYY hh:mm A")],
    ];

    const formattedStartDate = moment(startEndDate.start).format("D/M/YYYY");
    const formattedEndDate = moment(startEndDate.end).format("D/M/YYYY");
    headerSummary.push([`Date Range`, `${formattedStartDate} - ${formattedEndDate}`]);

    autotable(doc, {
      body: headerSummary,
      tableWidth: 100,
    });

    const tableData = list.map((training, i) => {
      return [
        i + 1,
        training.user.name,
        training.resource.name,
        training.mode,
        moment(training.startTime).format("DD/MM/YYY hh:mm a"),
        training.additionalId,
      ];
    });

    autotable(doc, {
      head: [["S.N", "Name", "Project", "Mode", "Timestamp", "Language"]],
      body: tableData,
    });

    doc.save("trainings.pdf");
  };

  const generateExcel = () => {
    const workbook = XLSX.utils.book_new();

    const tableData = list.map((training, i) => {
      return [
        i + 1,
        training.user.name,
        training.resource.name,
        training.mode,
        moment(training.startTime).format("DD/MM/YYY hh:mm a"),
        training.additionalId,
      ];
    });

    const worksheet = XLSX.utils.aoa_to_sheet([
      ["S.N", "Name", "Project", "Mode", "Timestamp", "Language"],
      ...tableData,
    ]);

    XLSX.utils.book_append_sheet(workbook, worksheet, "KPI List");
    XLSX.writeFile(workbook, "trainings.xlsx");
  };

  return (
    <>
      <div className="container-fluid bg-grey-main pt-4 px-5">
        <div className="forfixing">
          <div className="row mb-1 ">
            <div className="col-md-4 p-0">
              <div className="moudlendgroup">
                {/* <span className='backbtn' onClick={() => navigate(-1)}>  </span> */}
                <span
                  className="backbtn cursor-pointer mt-2"
                  title="Back"
                  style={{ fontSize: "20px" }}
                  onClick={() => navigate(-1)}
                >
                  {" "}
                  <BackIcon />{" "}
                </span>
                {group?.avatar ? (
                  <img
                    src={group?.avatar}
                    style={{ objectFit: "contain", width: "inherit" }}
                    referrerPolicy={"no-referrer"}
                  />
                ) : (
                  group?.name
                    ?.split(" ")
                    .map((word) => word[0])
                    .slice(0, 2)
                    .join("")
                )}
                <div className="data">
                  <h5> {group.name} </h5>
                  <p>Total Trainings</p>
                </div>
              </div>
            </div>
            <div className="col-md-8 d-flex justify-content-end gap-2 p-0">
              <button className="DefaultRedBtn download" title="Download PDF" onClick={generatePDF}>
                <PDFDownloadIcon />
              </button>
              <button className="DefaultRedBtn download" title="Download Excel" onClick={generateExcel}>
                <EXLDownloadIcon />
              </button>
            </div>
          </div>
        </div>
        {/* <DateRangeSelector /> */}
        <div className="row pt-2">
          <div className="table-responsive workflowtb stickyhead reports full-crn p-0">
            <table className="table align-middle table-nowrap mb-0">
              <thead>
                <tr>
                  <th> S.No </th>
                  <th> Name </th>
                  <th> Project </th>
                  <th> Mode </th>
                  <th> Timestamp </th>
                  <th> Language </th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <>
                    {[...Array(10)].map((_, index) => (
                      <tr key={index}>
                        <td>
                          <Skeleton width="3vw" />
                        </td>
                        <td>
                          <Skeleton width="5vw" />
                        </td>
                        <td>
                          <Skeleton width="5vw" />
                        </td>
                        <td>
                          <Skeleton width="5vw" />
                        </td>
                        <td>
                          <Skeleton width="5vw" />
                        </td>
                        <td>
                          <Skeleton width="5vw" />
                        </td>
                      </tr>
                    ))}
                  </>
                ) : (
                  <>
                    {list.length > 0 &&
                      list.map((e, index) => {
                        return (
                          <tr key={index + 1}>
                            <td>{index + 1 + currentPage * itemsPerPage}</td>
                            <td className="nameimage">
                              {e?.user?.avatar ? (
                                <img src={e?.user?.avatar} referrerPolicy={"no-referrer"} />
                              ) : (
                                <div className="initials-placeholder">
                                  {e.user.name
                                    ?.split(" ")
                                    .map((word) => word[0])
                                    .slice(0, 2)
                                    .join("")}
                                </div>
                              )}
                              {e.user.name}
                            </td>
                            <td> {e.resource.name} </td>
                            <td> {e.mode} </td>
                            <td> {moment(e.startTime).format("DD/MM/YYYY hh:mm a")} </td>
                            <td>
                              {" "}
                              {e.additionalId
                                ? e.additionalId.charAt(0).toUpperCase() + e.additionalId.slice(1)
                                : ""}{" "}
                            </td>
                          </tr>
                        );
                      })}
                  </>
                )}
              </tbody>
            </table>

            <ReactPaginate
              breakLabel="..."
              nextLabel="Next >"
              onPageChange={handlePageClick}
              pageRangeDisplayed={3}
              pageCount={pageCount}
              previousLabel="< Previous"
              renderOnZeroPageCount={null}
              containerClassName="userReportPagination"
              activeClassName="active"
              forcePage={currentPage}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default TotalTrainings;
